// import Printable from "components/modules/reporting/A4";
// import React, { useRef } from "react";
// import { Button, Card, Col, Form, Row } from "react-bootstrap";
// import { useLocation, useNavigate } from "react-router-dom";
// import { formatDate } from "utils/dateFormatter";
// import logo from "../../../../assets/img/logos/logoNew.png";

// export default function GeneralLedgerReport() {
//   const navigate = useNavigate();
//   const { state } = useLocation();
//   const printRef = useRef();

//   const triggerPrint = () => {
//     printRef.current?.handlePrint?.();
//   };

//   const totalDebit = state?.entries?.reduce(
//     (sum, entry) => sum + (entry.debit || 0),
//     0
//   );
//   const totalCredit = state?.entries?.reduce(
//     (sum, entry) => sum + (entry.credit || 0),
//     0
//   );

//   return (
//     <>
//       <Card>
//         <Card.Header className="border-bottom">
//           <Row className="flex-between-center ">
//             <Col md>
//               <div className="d-flex align-items-center">
//                 <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
//                   {" "}
//                   Reports | General Ledger
//                 </h5>
//                 <div className="d-flex align-items-center gap-2 mx-4">
//                   <span style={{ color: "black" }}>Ledger Number:</span>
//                   <Form.Group className="" controlId="formGroupBod">
//                     {/* <Form.Label>From Date: </Form.Label> */}
//                     <Form.Control
//                       type="text"
//                       placeholder="Enter Ledger Number"
//                     />
//                   </Form.Group>
//                   <span style={{ color: "black" }}>From Date:</span>
//                   <Form.Group className="" controlId="formGroupBod">
//                     {/* <Form.Label>From Date: </Form.Label> */}
//                     <Form.Control type="date" />
//                   </Form.Group>
//                   <span style={{ color: "black" }}>To Date:</span>
//                   <Form.Group className="" controlId="formGroupBod">
//                     {/* <Form.Label>To Date:</Form.Label> */}
//                     <Form.Control type="date" />
//                   </Form.Group>
//                 </div>
//               </div>
//             </Col>
//             <Col xs="auto">
//               <Button
//                 variant="link"
//                 className="text-secondary fw-medium p-0 me-3"
//                 type="button"
//                 onClick={() => navigate(-1)}
//               >
//                 Cancel
//               </Button>
//               <Button variant="primary" onClick={triggerPrint}>
//                 Print
//               </Button>
//             </Col>
//           </Row>
//         </Card.Header>

//         <Printable ref={printRef} documentTitle="General Ledger Report">
//           <div style={{ padding: 40, fontFamily: "Arial, sans-serif" }}>
//             {/* Header */}
//             <div className="d-flex justify-content-between">
//               <div>
//                 <div style={{ textAlign: "center", color: "black" }}>
//                   <img
//                     height={80}
//                     width={80}
//                     src={logo}
//                     alt="Logo"
//                     style={{ marginBottom: "20px" }}
//                   />
//                 </div>
//                 <h4 style={{ textAlign: "center", color: "black" }}>
//                   General Ledger
//                 </h4>
//               </div>
//               <div></div>
//             </div>

//             {/* Reference and Company */}
//             <div className="d-flex justify-content-between my-4">
//               <div>
//                 <strong>Company Name:</strong> ABC Corporation
//                 <br />
//                 <strong>Address:</strong> 123 Main St, City, Country
//               </div>
//               <div className="text-end">
//                 <div>
//                   <strong>REF. NO.:</strong> 123123124
//                 </div>
//                 <div>
//                   <strong>Generated:</strong> {new Date().toLocaleDateString()}
//                 </div>
//               </div>
//             </div>

//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 marginBottom: 20,
//               }}
//             >
//               <thead>
//                 <tr>
//                   <th style={styles.th}>DATE.</th>
//                   <th style={styles.th}>NAME</th>
//                   <th style={styles.th}>NOTE</th>
//                   <th style={styles.th}>DETAILS</th>
//                   <th style={styles.th}>DEBIT</th>
//                   <th style={styles.th}>CREDIT</th>
//                   <th style={styles.th}>BALANCE</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {Array.from({ length: 4 }, (_, index) => (
//                   <tr>
//                     <td style={styles.td}>19-2-2026</td>
//                     <td style={styles.td}>Customer One</td>
//                     <td style={styles.td}>Custom Note</td>
//                     <td style={styles.td}>Invoice:RCPT78966</td>
//                     <td style={styles.tdP}>1500</td>
//                     <td style={styles.tdP}>1900</td>
//                     <td style={styles.tdP}>400</td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot>
//                 <tr>
//                   <td colSpan={4} style={styles.tdFT} className="bold">
//                     Total:{" "}
//                   </td>
//                   <td style={styles.tdF}> </td>
//                   <td style={styles.tdF}>{totalCredit?.toLocaleString()}</td>
//                   <td style={styles.tdF}>{totalCredit?.toLocaleString()}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan={4} style={styles.tdFT} className="bold">
//                     Closing Balance:{" "}
//                   </td>
//                   <td style={styles.tdF}> </td>
//                   <td style={styles.tdF}> </td>
//                   <td style={styles.tdF}>{totalDebit?.toLocaleString()}</td>
//                 </tr>
//               </tfoot>
//             </table>

//             {/* <div
//               style={{
//                 textAlign: "right",
//                 fontWeight: "bold",
//                 marginBottom: 40,
//               }}
//             >
//               <div>Total Debit: {totalDebit.toLocaleString()}</div>
//               <div>Total Credit: {totalCredit.toLocaleString()}</div>
//             </div> */}

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginTop: 60,
//               }}
//             >
//               <div>APPROVED BY:</div>
//               <div
//                 style={{ borderBottom: "1px solid #000", width: "250px" }}
//               ></div>
//             </div>
//           </div>
//         </Printable>
//       </Card>
//     </>
//   );
// }

// const styles = {
//   printBtn: {
//     padding: "5px 10px",
//     backgroundColor: "#4CAF50",
//     color: "white",
//     border: "none",
//     borderRadius: "2px",
//     cursor: "pointer",
//     marginRight: "40px",
//   },
//   th: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//     fontWeight: "bold",
//   },
//   td: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//   },
//   tdP: {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//   },
//   tdFT: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#e6e6e6",
//   },
//   tdF: {
//     fontWeight: "bold",
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "right",
//     backgroundColor: "#e6e6e6",
//   },
// };

import Printable from "components/modules/reporting/A4";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Col, Collapse, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../assets/img/logos/logoNew.png";
import { formatDateRange } from "utils/formatter";
import Select from "react-select";
import { SearchAccountAPI } from "api";
import { Controller } from "react-hook-form";
import classNames from "classnames";
import debounce from "lodash.debounce";
import { useSettingContext } from "context/SettingContext";
import { useFetchFinanceBook } from "hooks/useFetchFinanceBook";
import ReactDatePickerE from "components/common/ReactDatePickerE";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import PageTitle from "utils/PageTitle";

const AsyncSelectField = ({ costCenterId, onChange, value }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      cursor: "pointer",
      borderColor: "#dbdbdb",
      "&:hover": { borderColor: "#dbdbdb" },
    }),
    input: (provided) => ({ ...provided, color: "black" }),
    menu: (provided) => ({ ...provided, color: "black", zIndex: 2 }),
  };

  const fetchOptions = async (query) => {
    if (!query) return [];
    try {
      const response = await SearchAccountAPI.get({
        params: { costCenterId: costCenterId, searchString: query },
      });
      return response?.data?.data || [];
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };

  const loadOptions = debounce(async (inputValue) => {
    if (inputValue.length < 3) {
      setOptions([]);
      return;
    }

    setLoading(true);
    const data = await fetchOptions(inputValue);
    setOptions(data);
    setLoading(false);
  }, 500);

  return (
    <Select
      value={value}
      className="basic-single"
      classNamePrefix="select"
      options={options}
      isLoading={loading}
      getOptionLabel={(option) => option.title}
      getOptionValue={(option) => option.id}
      onInputChange={loadOptions}
      onChange={onChange}
      placeholder="Account"
      styles={customStyles}
      isClearable
    />
  );
};

export default function GeneralLedgerReport() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const printRef = useRef();
  const headerRef = useRef();
  const collapseButtonRef = useRef();
  const [reportData, setReportData] = useState(null);
  const formatAmount = (amount) =>
    amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

  const triggerPrint = () => {
    printRef.current?.handlePrint?.();
  };

  // Sample data
  const data = {
    accountName: "Accounts Receivable",
    entries: Array.from({ length: 10 }, (_, i) => ({
      id: i + 1,
      account: `Cost of goods sold-${i + 1}`,
      date: `2023-01-${(i + 1).toString().padStart(2, "0")}`,
      voucherType: `Customer ${i + 1}`,
      voucherNumber: `STE - ${i + 1}`,
      againstAccount: `STE - ${i + 1}`,
      partyType: `STE - ${i + 1}`,
      party: `STE - ${i + 1}`,
      debit: i % 2 === 0 ? 1000 * (i + 1) : 0,
      credit: i % 2 === 0 ? 0 : 800 * (i + 1),
      balance: 10000 + (i % 2 === 0 ? 1000 * (i + 1) : -800 * (i + 1)),
    })),
  };

  const totalDebit = data.entries.reduce((sum, entry) => sum + entry.debit, 0);
  const totalCredit = data.entries.reduce(
    (sum, entry) => sum + entry.credit,
    0
  );
  const closingBalance = data.entries[data.entries.length - 1].balance;

  // Get initial dates
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  // State for dates
  const [fromDate, setFromDate] = useState(formatDateRange(firstDayOfMonth));
  const [toDate, setToDate] = useState(formatDateRange(today));
  const [selectedAccount, setSelectedAccount] = useState(null);

  const settingsData = useSettingContext();
  const costCenter = useMemo(
    () => settingsData?.find((d) => d.name === "DEFAULT_COST_CENTER"),
    [settingsData]
  );
  const costCenterId = Number(costCenter?.value) || 1; // Ensure it's a number

  const { data: financeBooksData, isLoading: financeBookLoading } =
    useFetchFinanceBook(costCenterId);

  const [collapseIn, setCollapseIn] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  const toggleFilters = () => setCollapseIn(!collapseIn);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const rect = headerRef.current.getBoundingClientRect();
        setIsHeaderVisible(rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <PageTitle name="Reports | General Ledger" />
      <Card>
        {/* <Card.Header className="border-bottom">
        <Row className="flex-between-center">
          <Col md>
            <div className="d-flex align-items-center">
              <h5
                className="fs-9 text-nowrap mb-2 mb-md-0"
                style={{ width: "19.5rem" }}
              >
                Reports | General Ledger
              </h5>
              <div className="d-flex align-items-center gap-2 ">
                <div style={{ width: "180px" }}>
                  <AsyncSelectField
                    costCenterId={costCenterId}
                    onChange={(selected) => setSelectedAccount(selected)}
                    value={selectedAccount}
                  />
                </div>
                <Form.Select
                  aria-label="Fiscal Year"
                  className="fs-9"
                  style={{ width: "180px" }}
                >
                  <option value="">Finance Book</option>
                  {financeBooksData?.data.data.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </Form.Select>
                <span style={{ color: "black" }}>From:</span>
                <Form.Group
                  controlId="formGroupFromDate"
                  style={{ width: "160px" }}
                >
                  <Form.Control
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </Form.Group>
                <span style={{ color: "black" }}>To:</span>
                <Form.Group
                  controlId="formGroupToDate"
                  style={{ width: "160px" }}
                >
                  <Form.Control
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </Form.Group>

                <Form.Check
                  type="checkbox"
                  id="defaultSwitch"
                  label={
                    <div style={{ marginBottom: 0 }}>Show Group account</div>
                  }
                  style={{
                    width: "max-content",
                    paddingTop: 4,
                    marginBottom: 0,
                    marginLeft: 10,
                  }}
                />
              </div>
            </div>
          </Col>
          <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={triggerPrint}>
              Print
            </Button>
          </Col>
        </Row>
      </Card.Header> */}

        <Card.Header
          ref={headerRef}
          className="border-bottom sticky-header"
          style={{
            position: "sticky",
            top: -90,
            backgroundColor: "white",
            zIndex: 1000,
            paddingBottom: collapseIn ? "1rem" : "1.5rem",
            transition: "padding-bottom 0.3s ease",
          }}
        >
          <div className="header-content">
            <Row className="flex-between-center align-items-center">
              <Col md>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <h5
                    className="fs-9 text-nowrap mb-2 mb-md-0"
                    style={{ width: "19.5rem" }}
                  >
                    Reports | General Ledger
                  </h5>
                  <div style={{ color: "black" }}>Date Range:</div>
                  <div style={{ width: "280px" }}>
                    <ReactDatePickerE />
                  </div>
                </div>
              </Col>
              <Col xs="auto">
                <Button
                  variant="link"
                  className="text-secondary fw-medium p-0 me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                {reportData ? (
                  <>
                    <Button variant="primary" onClick={triggerPrint}>
                      Print
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="primary">Preview</Button>
                  </>
                )}
              </Col>
            </Row>

            <Collapse in={collapseIn}>
              <div className="filter-row">
                <Row className="mt-3">
                  <Col
                    md="auto"
                    style={{
                      marginLeft: "20rem",
                      display: "flex",
                      gap: 10,
                    }}
                  >
                    <div style={{ width: "180px" }}>
                      <AsyncSelectField
                        costCenterId={costCenterId}
                        onChange={(selected) => setSelectedAccount(selected)}
                        value={selectedAccount}
                      />
                    </div>
                    <Form.Select
                      aria-label="Fiscal Year"
                      className="fs-9"
                      style={{ width: "180px" }}
                    >
                      <option value="">Finance Book</option>
                      {financeBooksData?.data.data.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </Form.Select>

                    <Form.Check
                      type="checkbox"
                      id="defaultSwitch"
                      label={
                        <div style={{ marginBottom: 0 }}>
                          Show Group account
                        </div>
                      }
                      style={{
                        width: "max-content",
                        paddingTop: 4,
                        marginBottom: 0,
                        marginLeft: 10,
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </Collapse>
          </div>

          {/* Collapse toggle button fixed to border-bottom */}
          <div
            ref={collapseButtonRef}
            style={{
              position: "absolute",
              right: "7.5rem",
              bottom: "-15px",
              zIndex: 1001,
              backgroundColor: "white",
              borderRadius: "50%",
              boxShadow: "0 0 0 2px white",
              visibility: isHeaderVisible ? "visible" : "hidden",
              transition: "visibility 0.2s ease",
            }}
          >
            {collapseIn ? (
              <IoIosArrowDropup
                title="Hide Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            ) : (
              <IoIosArrowDropdown
                title="Show Filters"
                size={30}
                onClick={toggleFilters}
                className="cursor-pointer"
              />
            )}
          </div>
        </Card.Header>

        <Printable ref={printRef} documentTitle="General Ledger Report">
          {reportData && (
            <div style={{ padding: 40, fontSize: "14px" }}>
              {/* Header */}
              <div className="d-flex justify-content-between">
                <div>
                  <div style={{ textAlign: "center", color: "black" }}>
                    <img
                      height={80}
                      width={80}
                      src={logo}
                      alt="Logo"
                      style={{ marginBottom: "20px" }}
                    />
                  </div>
                  <h4 style={{ textAlign: "center", color: "black" }}>
                    General Ledger
                  </h4>
                </div>
                <div></div>
              </div>

              {/* Reference and Company */}
              <div className="d-flex justify-content-between my-4">
                <div>
                  <strong>Company Name:</strong> ABC Corporation
                  <br />
                  <strong>Address:</strong> 123 Main St, City, Country
                </div>
                <div className="text-end">
                  <div>
                    <strong>Period:</strong> Jan 1, 2023 - Jan 31, 2023
                  </div>
                  <div>
                    <strong>Printed:</strong> {new Date().toLocaleDateString()}
                  </div>
                </div>
              </div>

              {/* Ledger Table */}
              <div style={{ marginTop: 30 }}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>SR. NO.</th>
                      <th style={styles.th}>POSTING DATE</th>
                      <th style={styles.th}>ACCOUNT</th>
                      <th style={styles.th}>DEBIT</th>
                      <th style={styles.th}>CREDIT</th>
                      <th style={styles.th}>VOUCHER TYPE</th>
                      <th style={styles.th}>VOUCHER NUMBER</th>
                      <th style={styles.th}>AGAINST ACCOUNT</th>
                      <th style={styles.th}>PARTY TYPE</th>
                      <th style={styles.th}>PARTY</th>
                      <th style={styles.th}>BALANCE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.entries.map((entry, index) => (
                      <tr key={entry.id}>
                        <td style={styles.td}>{index + 1}</td>
                        <td style={styles.td}>
                          {new Date(entry.date).toLocaleDateString()}
                        </td>
                        <td style={styles.td}>{entry.account}</td>
                        <td style={styles.tdP}>
                          {entry.debit ? formatAmount(entry.debit) : "-"}
                        </td>
                        <td style={styles.tdP}>
                          {entry.credit ? formatAmount(entry.credit) : "-"}
                        </td>
                        <td style={styles.td}>{entry.voucherType}</td>
                        <td style={styles.td}>{entry.voucherNumber}</td>
                        <td style={styles.td}>{entry.againstAccount}</td>
                        <td style={styles.td}>{entry.partyType}</td>
                        <td style={styles.td}>{entry.party}</td>

                        <td style={styles.tdP}>
                          {formatAmount(entry.balance)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={3} style={styles.tdTotal}>
                        <strong>TOTAL</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(totalDebit)}</strong>
                      </td>
                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(totalCredit)}</strong>
                      </td>
                      <td colSpan={6} style={styles.tdTotalP}></td>
                    </tr>
                    <tr>
                      <td colSpan={10} style={styles.tdTotal}>
                        <strong>CLOSING BALANCE</strong>
                      </td>

                      <td style={styles.tdTotalP}>
                        <strong>{formatAmount(closingBalance)}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Approval Signature */}
              <div
                style={{
                  marginTop: 100,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ width: 300, textAlign: "center" }}>
                  <div
                    style={{ borderBottom: "1px solid #000", marginBottom: 9 }}
                  ></div>
                  <div>Authorized Signature</div>
                </div>
              </div>
            </div>
          )}
        </Printable>
      </Card>
    </>
  );
}

const border = "1px solid #000";
const basePadding = "8px 10px";
const baseTextAlignLeft = "left";
const baseTextAlignRight = "right";

const bg = {
  lightGray: "#f8f8f8",
  gray: "#e6e6e6",
  darkGray: "#A9A9A9",
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20,
  },
  th: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    backgroundColor: bg.darkGray,
    fontWeight: "bold",
  },
  td: {
    border,
    // borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
  },
  tdP: {
    border,
    // borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
  },
  tdTotal: {
    border,
    // borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
  tdTotalP: {
    border,
    // borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
};
